// extracted by mini-css-extract-plugin
export default {"similar__container":"similars_similar__container__9Uj2+","similar__title":"similars_similar__title__WFdGF"};